import { gql } from '@apollo/client';

export const GET_COLLECTIONS = gql`
  query collectionsAdmin($filter: CollectionsFilter, $sort: CollectionsSort) {
    collectionsAdmin(filter: $filter, sort: $sort) {
      count
      collections {
        id
        title
        description
        itemsCount
        thumbnail {
          url
          blurhash
        }
      }
    }
  }
`;

export const GET_COLLECTION = gql`
  query collectionAdmin($id: ID!, $filter: CollectionItemsFilter) {
    collectionAdmin(where: { id: $id }) {
      id
      title
      description
      slug
      status
      primaryColor
      metaHeader
      metaFooter
      previewThumbnail {
        id
        url
      }
      thumbnail {
        id
        url
      }
      mobileThumbnail {
        id
        url
      }
    }
    collectionItemsAdmin(where: { id: $id }, filter: $filter) {
      count
      collectionItems {
        id
        type
        order
        sequence
        itemData {
          ... on Video {
            videoId: id
            title
            videoThumbnail {
              url
              id
            }
          }
          ... on Podcast {
            podcastId: id
            title
            imageThumbnail {
              url
              id
            }
          }
        }
        createdAt
      }
    }
  }
`;

export const GET_COLLECTION_ITEMS = gql`
  query CollectionItemsAdmin(
    $where: CollectionUniqueInput!
    $filter: CollectionItemsFilter
  ) {
    collectionItemsAdmin(where: $where, filter: $filter) {
      count
      collectionItems {
        id
        type
        order
        sequence
        itemData {
          ... on Video {
            videoId: id
            title
            videoThumbnail {
              url
              id
            }
          }
          ... on Podcast {
            podcastId: id
            title
            imageThumbnail {
              url
              id
            }
          }
        }
        createdAt
      }
    }
  }
`;
